<template>
  <div class="standings-top-page">
    <standings-top-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import StandingsTopPane from '@/components/StandingsPage/StandingsTopPane.vue'

/**
 * Standings: トップページ
 */
export default defineComponent({
  name: 'StandingsTopPage',
  components: {
    StandingsTopPane,
  },
})
</script>
